import React, { memo, useEffect, useState, useRef } from 'react'

export const PromoMessage = memo((props) => {
    const { promoMessage, onClose, idx, className, currentSlide } = props;
    const refContainer = useRef(false)
    const refContent = useRef(false)
    const [isOver, setIsOver] = useState(false)
    const [expandable, setExpandable] = useState(false)

    useEffect(() => {
        if (refContainer.current && refContent.current) {
            const rem = parseFloat(getComputedStyle(document.documentElement).fontSize)
            setIsOver(refContent.current.clientHeight > 3 * rem)
            setExpandable(refContent.current.clientHeight > 3 * rem)
        }
    }, [])

    const moreClick = () => {
        setIsOver(false)
    }

    const lessClick = () => {
        setIsOver(true)
    }

    useEffect(() => {
        lessClick()
    }, [currentSlide])

    const colStyle = {
        overflow: 'hidden',
        display: '-webkit-box',
        '-webkit-line-clamp': '2',
        '-webkit-box-orient': 'vertical'
    }

    const expStyle = {
        overflow: 'auto',
        display: 'block',
        '-webkit-line-clamp': 'none',
        '-webkit-box-orient': 'none'
    }

    const seeMoreContainerStyle = {
        width: '100%',
        textAlign: 'right',
    }

    // @TODO We need to sanitize the HTML content, but it can be dony in CSS, but first we need to be sure 
    // that the order loading CSS and JS correct, first CSS and then JS
    
    const sanitizedHtml = promoMessage.messageDesc.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');

    return (
        <div ref={refContainer} className={className || 'alert alert-dismissible fade show'} role="alert">
            {onClose && (
                <button
                    type="button"
                    onClick={() => onClose(idx)}
                    className="close"
                    data-dismiss="alert"
                    aria-label="Close"
                >
                    <span aria-hidden="true">×</span>
                </button>
            )}
            {promoMessage.messageTitle && <strong>{promoMessage.messageTitle}</strong>}
            <div
                ref={refContent}
                style={isOver ? colStyle : expStyle}
                dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
            />
            {expandable && (
                <div style={seeMoreContainerStyle}>
                    <a href="#" onClick={isOver ? moreClick : lessClick}>
                        {isOver ? 'See more' : 'See less'}
                    </a>
                </div>
            )}
        </div>
    )
})